import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";

export default function (element, dataset) {
  onMount(() => {
    const tags = element
      .closest(".page_main")
      .querySelectorAll(".bvl_tags_nest_item");
    const slot = element.querySelector(".u-display-contents");
    console.log(element, tags, slot);

    tags.forEach((e) => {
      slot.appendChild(e);
    });
  });
}
